import { css } from '@emotion/core'
import { measures } from 'styles/variables'

const { unit } = measures

export const logo = css`
  width: ${6 * unit}px;
  height: ${6 * unit}px;
  object-fit: contain;
`

export const imagePlaceholder = css`
  width: ${6 * unit}px;
  height: ${6 * unit}px;
  background-color: #f0f0f0;
  border-radius: 50%;
`

export const textContainer = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const container = css`
  display: flex;
  align-items: center;
  flex-direction: row;
`

export const customEventContainer = css`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  
  /* Make the custom event text more prominent */
  text-align: left;
  font-weight: bold;
  padding-left: ${1 * unit}px;
`

export const teamsContainer = css`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`

export const teamSection = css`
  display: flex;
  align-items: center;
  flex: 1;
  max-width: 45%;
`

export const separator = css`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 ${2 * unit}px;
  color: #666;
`
